import { combineEpics } from 'redux-observable';
import type { Action } from '../../state/actions/types.tsx';
import type { State } from '../../state/reducers/types.tsx';
import changeVisibilityEpic from './change-visibility/index.tsx';
import loadEpic from './load/index.tsx';
import reloadEpic from './reload/index.tsx';

// @ts-expect-error - TS2345: Type 'unknown' is not assignable to type 'Action'.
export default combineEpics<Action, State>(loadEpic, reloadEpic, changeVisibilityEpic);
